export default __webpack_public_path__ + "static/media/47.170b4009.gif";